import { TVersionControlConfig } from "~/versionControl/context";

/** !!! ВАЖНО !!!
 * По всему коду где будут расставлены специальные ограничения из раздела specificSet
 * НЕОБХОДИМО сразу же маркировать комментарием с названием конфига
 *
 * ПРИМЕР: (// VERSION_CONTROL_CAMERA_CFG) или JSX аналог
 *
 * Это нужно делать для того чтобы после утверждения модуля и полной
 * интеграции убирать метки и логику ограничений
 * */

const configs = [
  // VERSION_CONTROL_SRR_CFG,
  // VERSION_CONTROL_CAMERA_CFG,
  // VERSION_CONTROL_DEALER_PASSPORT_FORM_CFG,
  // VERSION_CONTROL_PHOTO_GALLERY_CFG,
  // VERSION_CONTROL_CONTRACT_TEMPLATES,
  // VERSION_CONTROL_ASP,
  // VERSION_CONTROL_KLADR,
  // VERSION_CONTROL_PKD,
  // VERSION_CONTROL_TRUSTED_PERSONS,
  // VERSION_CONTROL_IVIDEON_CAMERA_CFG,
];

export const versionConfigAggregation = (configs: TVersionControlConfig[]) => {
  const deepSpecificSetResolver = (
    updateState: { [key: string]: any },
    currentState: { [key: string]: any }
  ) => {
    return Object.keys(updateState).reduce((acc, element) => {
      const key = element;
      const currentStateHasProps = currentState.hasOwnProperty(key);
      if (
        currentStateHasProps &&
        typeof currentState[key] === "object" &&
        !Array.isArray(currentState[key])
      ) {
        return {
          ...currentState,
          ...acc,
          [key]: deepSpecificSetResolver(updateState[key], currentState[key]),
        };
      } else {
        return {
          ...currentState,
          ...acc,
          [key]: Array.isArray(updateState[key])
            ? [...currentState[key], ...updateState[key]]
            : updateState[key],
        };
      }
    }, {});
  };

  return (Array.isArray(configs) ? configs : []).reduce(
    (acc, config): TVersionControlConfig => {
      return {
        routeBlackList: [...acc.routeBlackList, ...config.routeBlackList],
        modulesBlockFlags: [
          ...acc.modulesBlockFlags,
          ...config.modulesBlockFlags,
        ],
        specificSet: deepSpecificSetResolver(
          config.specificSet,
          acc.specificSet
        ),
      };
    },
    {
      routeBlackList: [],
      modulesBlockFlags: [],
      specificSet: {},
    }
  );
};

export default versionConfigAggregation(configs);
